import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

const DashboardCard = ({
  textColor = "white",
  bgColor = "light",
  title,
  link,
  toggleClass,
  children,
}) => {
  return (
    <div className={`card text-${textColor} bg-${bgColor} mb-3`}>
      <div className="card-header display-7">
        {title}
        <a
          className="collapsed"
          data-toggle="collapse"
          href={`#${link}`}
          aria-expanded="true"
          aria-controls={link}
        >
          <span className="float-right">
            <FontAwesomeIcon
              icon={faPlus}
              aria-hidden="true"
              className={`toggle_plus_${toggleClass}`}
            />
            <FontAwesomeIcon icon={faMinus} aria-hidden="true" />
          </span>
        </a>
      </div>
      <div className="card-body">{children}</div>
    </div>
  );
};

export default DashboardCard;
